import {useProfile} from "../../context/ProfileContext";
import {Link} from "react-router-dom";

const ProfileMenu = () => {
    const {profile, isLoggedUser} = useProfile();

    if (!profile) {
        return <></>
    }

    return (
        <nav className="profile-menu p-0 slide-right">
            <div className="container-fluid">
                <Link className="btn btn-light" to={'/profile/edit'}>
                    <i className='fa fa-edit'></i> EDIT PROFILE
                </Link>
            </div>
        </nav>
    )
}

export default ProfileMenu;
